function priceFilterActions(target) {
  if (!this.$data.settings.filtersLocked) {
    this.setFilterVisibility('showPriceFilter');
    this.scrollToFilterSmallScreen(target);
  }
}
export default priceFilterActions;
